export const isDomainSecondLevel = (domain: string): boolean => {
  return domain.split('.').length === 2;
};

export const sanitiseDomain = (domain: string): string => {
  if (!domain) return '';

  // Normalize: trim, lowercase, remove http(s)://
  let normalized = domain
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '');

  // If starts with "www.", check if removing it makes it a second-level domain
  if (normalized.startsWith('www.')) {
    const withoutWww = normalized.replace(/^www\./i, '');
    if (isDomainSecondLevel(withoutWww)) {
      return withoutWww;
    }
  }

  return normalized;
};
